import styled from "styled-components";
import { colors, radii } from "../../../theme";

export const SectionContainer = styled.section`
  padding: 2.5rem 0;

  & + & {
    border-top: 1px solid rgba(210, 180, 140, 0.4);
    padding-top: 3.5rem;
  }
`;

export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 0.85rem;
  margin-bottom: 2rem;
`;

export const Title = styled.h2`
  font-size: clamp(1.6rem, 3vw, 2.1rem);
  color: ${colors.textMain};
`;

export const Count = styled.span`
  padding: 0.2rem 0.65rem;
  border-radius: ${radii.pill};
  background-color: ${colors.backgroundTernary};
  border: 1px solid rgba(210, 180, 140, 0.5);
  font-size: 0.85rem;
  font-weight: 600;
  color: ${colors.textSecondary};
`;
